import React from 'react'
import ReactNumberFormat from 'react-number-format'
import { getNumberSeparators } from '@paintscout/util/builder/util/format-number/format-number'
import { useCurrency } from '../../providers/CurrencyProvider'
import { useTranslation } from '../../providers/TranslationProvider/useTranslation'

export default function NumberFormat(props: {
  children?: any
  format?: string
  showUnits?: boolean
  showZeros?: boolean
  value?: number
  currencySymbol?: string
}) {
  const { children, format, showUnits, showZeros, value = 0, currencySymbol } = props
  const { symbol: contextSymbol } = useCurrency()
  const resolvedCurrencySymbol = currencySymbol ?? contextSymbol
  const { lang } = useTranslation()

  if (value || showZeros) {
    const numberFormatProps: any = {}
    numberFormatProps.decimalScale = 2
    // Separators follow the active language (fr: "1 234,5"); English keeps "1,234.5".
    const separators = getNumberSeparators(lang)
    numberFormatProps.thousandSeparator = separators.group
    numberFormatProps.decimalSeparator = separators.decimal
    if (format === 'price') {
      if (showUnits) {
        numberFormatProps.prefix = resolvedCurrencySymbol
      }
      numberFormatProps.fixedDecimalScale = true
    }
    if (format === 'hours' && showUnits) {
      numberFormatProps.suffix = ' hr'
    }
    return <ReactNumberFormat {...numberFormatProps} value={value} displayType="text" />
  } else if (children) {
    return children
  } else {
    return <>{''}</>
  }
}
